import React, { FC, useEffect, useState } from 'react'
import './EmploymentUpdate.scss'

import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'

interface propsType {
  toggleModal: () => void
  profile: any
  onSave: (data: EmploymentUpdateType) => Promise<boolean>
  users: any
}

export type EmploymentUpdateType = {
  jobTitle: string
  department: string
  employmentType: string
  lineManagerId: string
  employmentDate: string
  workLocation: string
}

const schema = yup.object().shape({
  jobTitle: yup.string().required('Field is required'),
  department: yup.string().required('Field is required'),
  employmentType: yup.string().required('Field is required'),
  lineManagerId: yup.string().required('Field is required'),
  employmentDate: yup.string().required('Field is required'),
  workLocation: yup
    .string()
    .required('Field is required')
    .max(60, 'Work location cannot exceed 60 characters'),
})

const EmploymentUpdate: FC<propsType> = ({ toggleModal, profile, onSave, users }) => {
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm<EmploymentUpdateType>({
    resolver: yupResolver(schema),
  })

  const { showAlert } = ShowTGAlert()
  const [request, setRequest] = useState(false)

  useEffect(() => {
    if (profile) {
      reset({
        jobTitle: profile.jobTitle,
        department: profile.department,
        employmentType: profile.employmentType,
        lineManagerId: profile.lineManagerId,
        employmentDate: profile.employmentDate,
        workLocation: profile.workLocation,
      })
    }
  }, [profile, reset])

  const submitEmployeeDeatils = handleSubmit(async (data: EmploymentUpdateType) => {
    setRequest(true)
    try {
      const success = await onSave(data)
      if (success) {
        toggleModal()
      }
    } finally {
      setRequest(false)
    }
  })

  // useEffect(() => {
  //   getAllUsers()
  // }, [])

  return (
    <div className='employment-update'>
      <form onSubmit={submitEmployeeDeatils}>
        <div className='form-group'>
          <label htmlFor='jobTitle' className=''>
            Job TItle
          </label>
          <input
            autoComplete='off'
            type='text'
            id='job_title'
            className={`form-control ${errors.jobTitle ? 'is-invalid' : ''}`}
            {...register('jobTitle', {
              required: 'Job title is required',
            })}
          />
          {errors.jobTitle && <div className='invalid-feedback'>{errors.jobTitle.message}</div>}
        </div>

        {/* Department */}
        <div className='form-group mt-3'>
          <label htmlFor='department' className=''>
            Department
          </label>

          <select
            autoComplete='off'
            id='department'
            className={`form-control custom-select ${errors.department ? 'is-invalid' : ''}`}
            {...register('department', {
              required: 'Department is required',
            })}
          >
            <option value=''>Select</option>
            <option>Finance Department</option>
            <option>Legal Department</option>
            <option>Corporate Communications Department</option>
            <option>Sales/Marketing Department</option>
            <option>Product Operations Department</option>
            <option>Product Engineering Department</option>
            <option>Human Resources Department</option>
          </select>

          {errors.department && (
            <div className='invalid-feedback d-block'>{errors.department.message}</div>
          )}
        </div>

        <div className='form-group mt-3'>
          <div className='formLine'>
            <label htmlFor='employmentType' className=''>
              Employment Type
            </label>

            <select
              autoComplete='off'
              id='employmentType'
              className={`form-control ${errors.employmentType ? 'is-invalid' : ''}`}
              {...register('employmentType', {
                required: 'field is required',
              })}
            >
              <option value=''>Select</option>
              <option>Full-time</option>
              <option>Part-time</option>
              <option>Contract</option>
            </select>
            {errors.employmentType && (
              <div className='invalid-feedback'>{errors.employmentType.message}</div>
            )}
          </div>
        </div>

        <div className='form-group mt-3'>
          <div className='formLine'>
            <label htmlFor='manager' className='mb-0'>
              Manager <span className='d-none d-md-inline'> / Supervisor</span>
            </label>

            <select
              id='manager'
              className={`form-control ${errors.lineManagerId ? 'is-invalid' : ''}`}
              {...register('lineManagerId', {
                required: 'Manager/Supervisor is required',
              })}
            >
              <option value=''>Select</option>

              {users?.map((user: any) => (
                <option
                  key={user.id}
                  value={`${user.id}`}
                  selected={user.id === profile?.lineManagerId}
                >
                  {user.firstName} {user.lastName}
                </option>
              ))}
            </select>

            {errors.lineManagerId && (
              <div className='invalid-feedback'>{errors.lineManagerId.message}</div>
            )}
          </div>
        </div>

        <div className='form-group mt-3'>
          <div className='formLine'>
            <label htmlFor='work_location' className=''>
              Work Location
            </label>

            <input
              autoComplete='off'
              type='text'
              id='work_location'
              className={`form-control custom-select ${errors.workLocation ? 'is-invalid' : ''}`}
              {...register('workLocation')}
            />
            {errors.workLocation && (
              <div className='invalid-feedback'>{errors.workLocation.message}</div>
            )}
          </div>
        </div>

        <div className='form-group mt-3'>
          <div className='formLine'>
            <label htmlFor='work_location' className=''>
              Employment Start Date
            </label>

            <input
              autoComplete='off'
              type='date'
              id='work_location'
              className={`form-control custom-select ${errors.employmentDate ? 'is-invalid' : ''}`}
              {...register('employmentDate')}
            />
            {errors.employmentDate && (
              <div className='invalid-feedback'>{errors.employmentDate.message}</div>
            )}
          </div>
        </div>

        <div className='form-group mt-4'>
          <button
            className='btn btn-default-2 w-100'
            // onClick={(e) => submitNewUserInformation(e)}
            disabled={request}
          >
            Save Details {request && <span className='spinner-border spinner-border-sm'></span>}
          </button>
        </div>
      </form>
    </div>
  )
}

export default EmploymentUpdate
